module.exports = __webpack_public_path__ + "img/sipuni.png";